import { fullName, type GulaClient } from "../gulaTypes";
import { searchDigits } from "./pendingCall";

export type Row = Pick<
  GulaClient,
  | "id"
  | "first_name"
  | "last_name"
  | "phone"
  | "stage"
  | "sales_id"
  | "zone"
  | "last_call_attempt_at"
>;

const RECENT_MS = 48 * 60 * 60 * 1000;

const normalize = (text: string) =>
  text.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");

/** Who might be calling: whoever was called in the last 48 h, newest first. */
export const recentlyCalled = (rows: Row[], now = Date.now()) =>
  rows
    .filter(
      (row) =>
        row.last_call_attempt_at &&
        now - Date.parse(row.last_call_attempt_at) <= RECENT_MS,
    )
    .sort(
      (a, b) =>
        Date.parse(b.last_call_attempt_at ?? "") -
        Date.parse(a.last_call_attempt_at ?? ""),
    );

/** Search by name or by any piece of the phone number. */
export const searchClients = (rows: Row[], text: string) => {
  const digits = searchDigits(text);
  const words = normalize(text.replace(/[0-9+\-\s()]/g, " ")).trim();
  return rows.filter((row) => {
    if (digits.length >= 3) {
      const phone = searchDigits(row.phone ?? "");
      // "+34 699…" typed against a number stored without the prefix
      const local = digits.replace(/^(00)?34(?=\d{3})/, "");
      if (
        phone.includes(digits) ||
        (local.length >= 3 && phone.includes(local))
      )
        return true;
    }
    if (words) {
      return normalize(fullName(row as GulaClient)).includes(words);
    }
    return false;
  });
};
